import { ColorScheme, ColorSchemeLabels, type ColorSchemeId } from '@stackje/common/colorScheme';
import { generateNewColors as _generateNewColors, generateNewColorsFromHex as _generateNewColorsFromHex } from '@stackje/common/color-utils';
import { getTailwindColor } from './tailwind-utils';
import type { ColorSchemeItem } from '@/components/shared/ColorSchemeSelector';

// Re-export from @stackje/common for backward compatibility
export const generateNewColors = _generateNewColors;
export const generateNewColorsFromHex = _generateNewColorsFromHex;

/**
 * Get available color schemes based on user email
 * Users with @ruqqq.sg domain get access to the exclusive Stack.je Brand color scheme
 */
export const getAvailableColorSchemes = (userEmail?: string): ColorSchemeItem[] => {
  const allSchemes = Object.entries(ColorScheme)
    .filter(([key]) => key !== 'custom') // Exclude custom scheme from the list
    .map(([key, colors]) => ({
      id: key,
      name: ColorSchemeLabels[key as ColorSchemeId],
      visual: colors.map((color) => {
        const colorName = color.replace(/-[0-9]+$/, "");
        if (colorName === "white" || colorName === "black") {
          return { color: colorName };
        }

        const colorNumber = color.match(/-[0-9]+$/)?.[0]?.replace("-", "");
        const colorValue = getTailwindColor(colorName)[colorNumber ?? "500"];
        return { color: colorValue };
      }),
    }));

  // Check if user has @ruqqq.sg email domain
  if (userEmail?.endsWith('@ruqqq.sg') || userEmail?.endsWith('@stack.je') || userEmail === 'stackje.team@gmail.com') {
    return allSchemes; // Include stackje-brand and all other schemes
  }

  // Filter out the stackje-brand for all other users
  return allSchemes.filter(scheme => scheme.id !== 'stackje-brand');
};

/**
 * Check if a user has access to exclusive color schemes
 */
export const hasExclusiveColorSchemeAccess = (userEmail?: string): boolean => {
  return userEmail?.endsWith('@ruqqq.sg') ?? false;
};
